import ForgotPasswordModalProvider from './ForgotPasswordModalProvider';

window.tnew.page.initialize = ({ autoShowForgotPasswordModal }) => {
  const forgotPasswordModalProvider = new ForgotPasswordModalProvider();

  forgotPasswordModalProvider.listen();

  if (autoShowForgotPasswordModal) {
    forgotPasswordModalProvider.showModal();
  }
};



// WEBPACK FOOTER //
// ./src/account/login/account-login.js